import Vue from 'vue'
import Vuex from 'vuex'
import user from '~/store/modules/user'
import auth from '~/store/modules/auth'
import shared from '~/store/modules/shared'
import projects from '~/store/modules/projects'
import { axios } from '~/plugins/axios'
import reports_speech_analysis from '~/store/modules/reports/speech_analysis'
import reports_project_service from '~/store/modules/reports/project_service'
import reports from '~/store/modules/reports'
import audioPlayer from '~/store/modules/audioPlayer'
import transcribe from '~/store/modules/transcribe'
import tariffs from '~/store/modules/tariffs'
import tariffications from '~/store/modules/reports/tariffications'
import operators from '~/store/modules/reports/operators'
import by_days from '~/store/modules/reports/by_days'
import complaints_report from '~/store/modules/reports/complaints_report'
import kln_by_operators from '~/store/modules/reports/kln_by_operators'
import form_report from '~/store/modules/reports/form_report'
import form_statistic_report from '~/store/modules/reports/form_statistic_report'
import graphql from '~/store/modules/graphql'
import timeline from '~/store/modules/timeline'
import dashboard from '~/store/modules/dashboard'
import duration_talk from '~/store/modules/reports/duration_talk'
import target_ai from '~/store/modules/reports/target_ai'
import notifications from '~/store/modules/notifications'
import call_tasks from '~/store/modules/call_tasks'
import prompter_search_results from '~/store/modules/reports/prompter_search_results'
import kpi_rg from '~/store/modules/reports/kpi_rg'
import wfm from '~/store/modules/reports/wfm'
import client_activity from '~/store/modules/reports/client_activity'

import calculator from './modules/otm/calculator.js'
import saved_margin_reports from './modules/otm/saved_margin_reports.js'
import dynamic_reports from './modules/dynamic-reports'
import document_flow_invoices from './modules/document_flow/invoices.js'
import document_flow_workloads from './modules/document_flow/workloads.js'

const otm = {
  namespaced: true,
  modules: { calculator, saved_margin_reports },
};

const document_flow = {
  namespaced: true,
  modules: { invoices: document_flow_invoices, workloads: document_flow_workloads },
};

const auto_complaints = (() => {
  const context = require.context('./modules/auto_complaints', false, /\.js$/)
  return context.keys().reduce((merged, key) => {
    const mod = context(key).default || context(key)
    return {
      namespaced: true,
      state: Object.assign({}, merged.state, typeof mod.state === 'function' ? mod.state() : mod.state),
      getters: Object.assign({}, merged.getters, mod.getters),
      actions: Object.assign({}, merged.actions, mod.actions),
      mutations: Object.assign({}, merged.mutations, mod.mutations),
    }
  }, { namespaced: true, state: {}, getters: {}, actions: {}, mutations: {} })
})()

Vue.use(Vuex)

const axiosPlugin = store => {
  store.$axios = axios
}

export default new Vuex.Store({
  modules: {
    auth,
    audioPlayer,
    by_days,
    complaints_report,
    kln_by_operators,
    dashboard,
    duration_talk,
    form_report,
    form_statistic_report,
    graphql,
    operators,
    projects,
    reports_project_service,
    reports_speech_analysis,
    reports,
    shared,
    tariffications,
    tariffs,
    timeline,
    transcribe,
    user,
    target_ai,
    otm,
    document_flow,
    notifications,
    auto_complaints,
    call_tasks,
    dynamic_reports,
    prompter_search_results,
    kpi_rg,
    wfm,
    client_activity,
  },

  plugins: [axiosPlugin],

  actions: {
    resetAllState({commit}) {
      commit('projects/RESET_STATE_PROJECTS')
      commit('reports/RESET_STATE_REPORTS')
      commit('operators/RESET_STATE_OPERATORS')
      commit('reports_project_service/RESET_STATE_PROJECTSERVICE')
      commit('reports_speech_analysis/RESET_STATE_SPEECHANALYSIS')
      commit('tariffications/RESET_STATE_TARIFFICATIONS')
      commit('tariffs/RESET_STATE_TARIFFS')
      commit('transcribe/RESET_STATE_TRANSCRIBE')
      commit('audioPlayer/RESET_STATE_AUDIOPLAYER')
    },
  },
})
